import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=528c97e0&scoped=true"
import script from "./focus.vue?vue&type=script&lang=js"
export * from "./focus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c97e0",
  null
  
)

export default component.exports